import {zodResolver} from '@hookform/resolvers/zod'
import {z} from 'zod'
import {isPhoneNumberValid, phoneNumberToString} from '../utils/phoneNumberUtils'

const phoneNumberSchema = z
  .object({
    dialingCode: z.string().min(1, 'Dialing code is required'),
    country: z.string().min(1, 'Country is required'),
    number: z.string().min(1, 'Phone number is required')
  })
  .refine((data) => isPhoneNumberValid(phoneNumberToString(data) ?? '', data.country), {
    message: 'Invalid phone number',
    path: ['number']
  })

const siteContactSchema = z.object({
  name: z.string().trim().min(1, 'Site contact name is required'),
  phoneNumber: phoneNumberSchema
})

const jobSiteAddressSchema = z.object({
  street: z.string().trim().min(1, 'Street is required'),
  streetNumber: z.string().trim().optional(),
  postalCode: z.string().trim().min(1, 'Postal code is required'),
  city: z.string().trim().min(1, 'City is required'),
  country: z.string().trim().min(1, 'Country is required'),
  latitude: z.number({invalid_type_error: 'Invalid latitude'}).finite(),
  longitude: z.number({invalid_type_error: 'Invalid longitude'}).finite()
})

const shipToCreationFormSchema = z.object({
  jobSiteName: z.string().optional(),
  jobSiteAddress: jobSiteAddressSchema,
  siteContact: siteContactSchema
})

export type ShipToCreationFormSchema = z.infer<typeof shipToCreationFormSchema>

export const buildShipToCreationResolver = () => {
  return zodResolver(shipToCreationFormSchema)
}
